<template>

  <div class="mr-3">
    <template v-if="mission?.mis_misc?.typeroute == 'waypoint'">
      <img :style="'width: ' + (img_size) + 'px'" src="/assets/images/mission/routes_types/waypoint.svg"
        :alt="$e('Mission de type <<Waypoint>>')">
    </template>
    <template v-else-if="mission?.mis_misc?.typeroute == 'mapping2d'">
      <img :style="'width: ' + (img_size) + 'px'" src="/assets/images/mission/routes_types/wayline-mapping.svg"
        :alt="$e('Mission de type <<Wayline-mapping>>')">
    </template>
    <template v-else-if="mission?.mis_misc?.typeroute == 'mappingPrism'">
      <img :style="'width: ' + (img_size - 5) + 'px'" src="/assets/images/mission/routes_types/geometric_route.svg"
        alt="Mission de type <<Wayline-mapping>>')">
    </template>
    <template v-else>
      <img :style="'width: ' + (img_size) + 'px'" src="/assets/images/mission/routes_types/no_type.svg"
        :alt="$e('Mission de type inconnu')">
    </template>
  </div>

  <div>
    <div class="leading-[10px] font-medium">
      #{{ mission.mis_id }} - {{ mission.mis_text }}
    </div>

    <div class="text-g3 flex items-center text-xs leading-[25px]">
      <template v-if="DroneIdExist(mission?.mis_misc?.droneID)">
        <svg class="fill-current w-[12px] mr-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 67.71 67.67">
          <path
            d="M14.47.03c7.63,0,13.95,5.95,14.4,13.57l.03.86h-4.86c.02-3.81-2.24-7.27-5.74-8.78-1.7-.76-3.6-.99-5.43-.67-5.21.89-8.72,5.83-7.83,11.04.4,2.38,1.69,4.51,3.6,5.98,1.47,1.14,3.25,1.81,5.11,1.93l.72.03v4.85c-1.89,0-3.77-.36-5.52-1.08-1.75-.73-3.34-1.8-4.68-3.14-1.34-1.33-2.41-2.92-3.13-4.66-1.46-3.54-1.46-7.52,0-11.07.73-1.75,1.79-3.33,3.13-4.66,1.34-1.34,2.93-2.41,4.68-3.14C10.69.38,12.57,0,14.47,0v.03ZM14.47,38.4v4.85c-1.88,0-3.71.54-5.29,1.55-1.58,1.02-2.82,2.47-3.58,4.19-1.55,3.52-.86,7.62,1.75,10.43,1.27,1.38,2.93,2.36,4.75,2.79,1.82.47,3.74.38,5.51-.25,1.77-.64,3.32-1.77,4.46-3.27,1.14-1.49,1.81-3.29,1.94-5.17l.03-.7h4.85c.01,7.98-6.44,14.45-14.42,14.47S.01,60.85,0,52.87c-.01-7.66,5.96-14,13.61-14.44l.85-.03h0ZM52.86,38.4c8.08-.12,14.73,6.34,14.85,14.42.12,8.08-6.34,14.73-14.42,14.85-7.92.12-14.5-6.1-14.83-14.01l-.02-.82h4.86c0,1.86.54,3.68,1.56,5.23,1.02,1.56,2.48,2.79,4.18,3.55,1.71.73,3.59.96,5.43.67,1.84-.32,3.54-1.17,4.91-2.44,1.37-1.26,2.33-2.89,2.78-4.69.45-1.81.36-3.72-.25-5.49-1.27-3.58-4.53-6.07-8.32-6.37l-.72-.03v-4.85h0ZM52.86.03c7.97,0,14.42,6.48,14.41,14.44,0,7.62-5.95,13.92-13.56,14.38l-.85.03v-4.88c1.88.03,3.72-.5,5.3-1.52,1.57-1.03,2.81-2.5,3.57-4.22.76-1.72.99-3.63.68-5.49-.64-3.78-3.46-6.82-7.19-7.74-5.16-1.27-10.37,1.88-11.64,7.03-.13.54-.22,1.1-.26,1.66l-.03.73h-4.86c0-3.83,1.52-7.5,4.23-10.21,1.33-1.34,2.93-2.4,4.68-3.11,1.75-.73,3.62-1.11,5.52-1.11h0ZM53.51,50.1c.42.18.8.45,1.1.79.29.36.48.78.56,1.24.08.46.03.93-.13,1.36-.15.43-.42.82-.78,1.11-.35.3-.77.49-1.23.57-.45.1-.92.06-1.35-.1-.43-.17-.82-.44-1.12-.79-.3-.34-.5-.76-.59-1.2-.47-.7-1.02-1.33-1.64-1.9-1.06-.95-2.16-1.83-3.32-2.66-3.11-2.91-7.03-4.79-11.24-5.39-3.47.41-6.75,1.84-9.4,4.12-.77.54-2.26,1.68-4.2,3.11-1.23.96-2.27,2.13-3.08,3.46l-.03-.03c-.19.4-.49.74-.86.98-.37.25-.79.42-1.23.48-.44.03-.88-.03-1.29-.19-.41-.17-.78-.44-1.05-.79-.27-.34-.46-.74-.55-1.17-.08-.44-.05-.9.09-1.33.14-.41.38-.79.7-1.08.32-.31.71-.53,1.15-.63,1.13-.37,2.13-1.08,2.85-2.03,1.42-1.62,2.76-3.33,4.01-5.07,2.18-2.5,3.59-5.57,4.07-8.85-.33-3.18-1.65-6.17-3.76-8.56-.67-1.01-2.12-2.85-3.57-4.66-1.14-1.55-2.58-2.87-4.23-3.87-.38-.22-.71-.54-.94-.92-.23-.37-.37-.8-.39-1.24-.05-.9.37-1.77,1.11-2.28.37-.25.79-.42,1.23-.48.44-.05.89.02,1.29.19.41.16.78.42,1.06.76.28.35.47.76.55,1.21.97,1.53,2.18,2.89,3.58,4.03,0,0,3.24,2.44,4.07,2.98,5.58,3.72,12.88,3.58,18.31-.35,1.87-1.52,5.04-3.96,5.04-3.96.68-.68,1.23-1.49,1.6-2.38.02-.47.17-.93.43-1.33.26-.39.62-.7,1.03-.92.43-.19.89-.29,1.36-.29.95.09,1.79.66,2.22,1.52.2.42.29.89.25,1.36-.04.47-.2.91-.46,1.3-.27.38-.64.69-1.06.89-1.07.59-1.99,1.43-2.69,2.44,0,0-1.68,2.35-3.71,4.95-5.33,4.41-6.08,12.3-1.67,17.63.59.72,1.26,1.37,2,1.94,1.16,1.71,2.5,3.29,3.99,4.72.55.55,1.18,1.01,1.86,1.36l.03-.02Z" />
        </svg>
        {{ $root.device_type_domain[mission.mis_misc.droneID].name }} |
      </template>

      {{ mission.mislength.toFixed(0) }} m | {{ mission.mispoints ? mission.mispoints : 0 }} points
    </div>
  </div>

</template>
<script>
export default {
  name: "Mission_Info_List_small",
  props: {
    mission: {
      type: Object,
      required: true
    },
    img_size: {
      type: Number,
      default: 28
    }
  },

  methods: {
    DroneIdExist(drone_id) {
      return this.$root.device_type_domain.hasOwnProperty(drone_id)
    }
  },
};
</script>
